import React, { ReactNode, useEffect, useRef } from "react";
import { modal } from "./Modals";
import "./Modals.scss";
import AuiFileUpload from "../AuiDropdown/AuiFIleUpload";
export type align = "left" | "center" | "right";

export interface AuiModalConfirmationModalProps {
  text?: string | ReactNode;
  title: string | ReactNode;
  icon?: string | ReactNode;
  alertText: string;
  handleConfirmationClick: () => void;
  buttontitle: string;
  cancelButtonTitle?: string;
  close?: () => void;
  headingAlign?: align;
  modalsize?: modal;
  modalType?: "normal-modal" | "input-modal" | "upload-modal";
  auiFileUploadProps?: React.ComponentProps<typeof AuiFileUpload>;
  uploadedFiles?: FileList | null | string;
  setUploadedFiles?: React.Dispatch<
    React.SetStateAction<FileList | null | string>
  >;
  children?: any;
  resetModal?: () => void;
  disableActionButton?: boolean;
  action?: Function;
  triggerRef?: React.RefObject<HTMLElement>;
}

const AuiConfirmationModal: React.FC<AuiModalConfirmationModalProps> = ({
  text,
  icon,
  alertText,
  handleConfirmationClick,
  buttontitle,
  cancelButtonTitle = "Cancel",
  close,
  title,
  headingAlign = "center",
  modalsize,
  modalType = "normal-modal",
  auiFileUploadProps,
  uploadedFiles,
  setUploadedFiles,
  children,
  resetModal,
  disableActionButton = false,
  action,
}) => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const modal = modalRef.current;
    modal?.focus();
  }, []);
  

  return (
    <aui-confirmationmodal modalsize={modalsize}>
      <div
        className="modal fade auimodal position-fixed"
        id="exampleModal"
        aria-modal="true"
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        ref={modalRef}
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content d-block">
            <div>
              <div className="d-flex flex-column flex-sm-row">
                <div className="d-block">
                  <div>
                    {title && (
                      <div
                        className={`modal-header pb-2 pl-0 pt-0 border-0${headingAlign ? " " + headingAlign : ""}`}
                      >
                        <aui-modal-headtag>
                          <div id="modal-title" data-testid="header-title">
                            {title}
                          </div>
                        </aui-modal-headtag>
                      </div>
                    )}
                  </div>
                  <p
                    id="modal-description"
                    data-testid="confirmation-test"
                    className="aui-confirmationtext font-18 mb-0 lh-28 text-center font-400 h8"
                  >
                    {text}
                  </p>
                </div>
              </div>
              {/* Conditional rendering for modal types */}
              <aui-modal-content>
                {modalType === "normal-modal" && (
                  <div className={`modal-body d-block ${modalType}`}>
                    {children}
                  </div>
                )}
                {modalType === "input-modal" && (
                  <div className="modal-body">
                    <aui-textarea
                      id="input-textarea"
                      textareaid="primary-textarea"
                      label="Add note"
                      data-test="add-note-id"
                      labelgrid="col-sm-3"
                      textareagrid="col-sm-9"
                      minlength={10}
                      maxlength={255}
                      enableautofocus={false}
                      required={true}
                      direction="column"
                    ></aui-textarea>
                  </div>
                )}
                {modalType === "upload-modal" && auiFileUploadProps && (
                  <div className="modal-body d-block">
                    <AuiFileUpload {...auiFileUploadProps} />
                  </div>
                )}

                <div className="d-flex align-items-center justify-content-end auimodals-buttons mt-4 modal-footer p-0">
                  <span>
                    <aui-button
                      size="medium"
                      variant="read-more"
                      buttontitle={cancelButtonTitle}
                      tabIndexAnchor={3}
                      data-dismiss="modal"
                      data-testid="clear-text"
                      onClick={(
                        e: React.MouseEvent<HTMLSpanElement, MouseEvent>
                      ) => {
                        e.preventDefault();
                        if (close) {
                          close();
                        }
                        resetModal?.();
                        setUploadedFiles?.(null);
                      }}
                      buttonclass="aui-modal-button-width aui-modal-btn-trap aui-uploaddocument-btn-close aui-modalclosecls"
                    ></aui-button>
                  </span>
                  {modalType === "upload-modal" &&
                  (!uploadedFiles || uploadedFiles.length === 0) ? (
                    <span>
                      <aui-button
                        size="medium"
                        variant="primary"
                        tabIndexAnchor={3}
                        buttontitle={buttontitle}
                        data-dismiss="modal"
                        buttonclass="aui-modal-button-width aui-modal-btn-trap"
                        data-testid="disable-confirm-button"
                        disabled={true}
                        onClick={(e: any) => {
                          e.stopPropagation();
                          handleConfirmationClick();
                        }}
                      ></aui-button>
                    </span>
                  ) : (
                    <span>
                      <aui-button
                        size="medium"
                        variant="primary"
                        tabIndexAnchor={3}
                        buttontitle={buttontitle}
                        data-dismiss="modal"
                        buttonclass="aui-modal-button-width aui-modal-btn-trap"
                        data-testid="confirm-button"
                        onClick={(e: any) => {
                          action?.();
                          e.stopPropagation();
                          handleConfirmationClick();
                          resetModal?.();
                        }}
                      ></aui-button>
                    </span>
                  )}
                </div>
              </aui-modal-content>
            </div>
          </div>
        </div>
      </div>
    </aui-confirmationmodal>
  );
};

export { AuiConfirmationModal };
